import { max } from 'moment';
import styled, { css } from "styled-components";

export const commonStyles = css`
  .containerFreteGratisListagem {
    width: 100rem;
    max-width: 90vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    .titulo{
      margin-bottom: 0;
    }

    .textoFreteGratis{
      text-align: left;
      padding: 1rem 0 4rem;
      width: 90%;
      color: ${(props) => props.theme.colors.tertiary};
      position: relative;
    }

    .linha{
      width: 30%;
      height: 2px;
      border-radius: 100%;
      background-color: ${(props) => props.theme.colors.elements};
    }

    .filtros-frete{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 2rem;

      .busca-listagem{
        flex-grow: 1;
      }

      .select-filtro-fretes{
        width: 20%;

        @media (max-width: 768px) {
          width: 40%;
        }
      }
    }

    .rodapeListagem {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr auto 1fr;
      align-items: center;
      gap: 2rem;

      .paginacaoListagem > div {
        justify-content: flex-start;
      }

      @media (max-width: 768px) {
        display: flex;
        flex-direction: column;

        .paginacaoListagem > div {
          justify-content: center;
        }
      }
    }

    .freteGratisContainer{
      width: 90%;
      .tableContainer{
        width: 90%;
        >table{
          >thead{
            >tr{
              >th{
                .th-wrapper{
                  padding: 2rem;
                }
              }
            }
          }
        }
        .editar{
          color: ${(props) => props.theme.colors.primary};
          cursor: pointer;
        }
      }
    }
    

    > .novo {
      margin-top: 4rem;
      color: ${(props) => props.theme.colors.primary};
      cursor: pointer;
      text-align: center;
    }
  }
`;

export const ContainerFreteGratisListagem = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles};
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      .containerFreteGratisListagem {
        width: 100%;

        .textoFreteGratis{
          padding: 3rem 0 0;
          width: 100%;
          &::after{
            bottom: -10px;
          }
        }
        .freteGratisContainer{
          width: 100%;
          .tableContainer{
            width: 100%;
          }
        }

        .novo {
          margin-top: 0;
          text-align: center;
        }
      }
    `}
`;